export const FINANCE_SUB_MODULES = {
  PROJECTS: 'PROJECTS',
  VENDORS: 'VENDORS',
  /** Budgets (quarter sheets, 25 Oct 2026): opt-in — an empty section list never includes it; Admins map the HR head and Accounts to it. */
  BUDGETS: 'BUDGETS',
};
/** Sections a person gets only when mapped to them (mirrors the server's OPT_IN_SUB_MODULES). */
export const OPT_IN_FINANCE_SECTIONS: string[] = [FINANCE_SUB_MODULES.BUDGETS];

export function getFinanceSubModules(): string[] {
  try {
    const raw = localStorage.getItem('subModules') || localStorage.getItem('subModuleAccess');
    if (!raw) return [];
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (!parsed) return [];

    if (typeof parsed === 'object' && !Array.isArray(parsed)) {
      const financeKey = Object.keys(parsed).find(k => k.trim().toUpperCase() === 'FINANCE');
      if (financeKey && Array.isArray(parsed[financeKey])) {
        return parsed[financeKey].map((s: string) => String(s).trim().toUpperCase());
      }
    }

    if (Array.isArray(parsed)) {
      return parsed.map((s: any) => String(s).trim().toUpperCase());
    }
  } catch (e) {
    console.error('Error parsing subModules:', e);
  }
  return [];
}

export function hasFinanceSubModuleAccess(subModule: string): boolean {
  const modulesStr = localStorage.getItem('modules') || '';
  const userModules = modulesStr
    .split(',')
    .map((m) => m.trim().toUpperCase())
    .filter(Boolean);

  if (!userModules.includes('FINANCE')) {
    return false;
  }
  // An Admin too opens only the sections ticked in their own Manage Access, as the server's guard
  // decides (founder, 3 Nov 2026).
  const subModules = getFinanceSubModules();
  const wanted = subModule.trim().toUpperCase();
  // An empty section list means every section — except the opt-in ones, which need an explicit mapping.
  if (!subModules.length) return !OPT_IN_FINANCE_SECTIONS.includes(wanted);
  return subModules.includes(wanted);
}

